export default __webpack_public_path__ + "static/media/friendzies.7bbdac1c.jpg";